export const ACTION_SET_GREETING = 'ACTION_SET_GREETING';

export const actionSetGreeting = (greeting)=>{
    return {
        type : ACTION_SET_GREETING,
        payload: greeting
    }
}

